module.exports = __webpack_public_path__ + "media/images/partners/ocenka2025-8550c7e6c510acba13b55434060d602b.svg";